import {
    getAnalyticsTag,
    getFlightsTag,
    loadAnalytics,
    priceTransform,
    sendGoogleConversionEvent,
    sendGoogleErrorEvent,
    sendGooglePriceAccuracyEvent
} from './google_analytics';

window.addEventListener("load", () => {
    const flightsTag = getFlightsTag()
    const analyticsTag = getAnalyticsTag()

    if (flightsTag || analyticsTag) loadAnalytics();
    if (!flightsTag) return false;

    loadAnalytics();
    const currency = document.getElementsByTagName('body')[0].getAttribute('currency');

    // step1 landing -> price accuracy event
    //
    // Google's gates are configured to send their clicks straight to step2
    // (F-ENGINE's direct_to_step2?, a per-gate setting), so in practice this
    // branch does not run and step2's event below is the one that reports.
    // It exists for the case where that setting is off for a Google gate --
    // in which case step1 IS the landing page Google is measuring, and
    // reporting nothing from it is the same as having no implementation.
    //
    // This replaces a branch that keyed off `top_step_1`, a class that
    // exists nowhere in this repo and never did on master either: it could
    // not have fired on any design, which is exactly why nobody noticed.
    // The legacy mobile version did fire, and read .price[0] -- the
    // PER-PERSON figure on any multi-passenger search -- so restoring that
    // would mean self-reporting a price we know is wrong to the programme
    // whose entire purpose is checking that our price matches.
    //
    // What is reported instead: the pinned card, i.e. the itinerary that was
    // actually clicked on Google, at its party total in the same basis as
    // the clickedPrice Google sent us (MetaController#extract_meta_data sums
    // clickedPrice + the two baggage fees). Deferred to step1:results-loaded
    // because the list arrives over AJAX, well after window "load".
    const step1 = document.querySelector("[data-step1-results-target='results']");
    if (step1) {
        // Only a real clickout landing. An ordinary search on a Google-tagged
        // gate must stay silent -- it has no clicked price to be accurate
        // about, and the FLIGHT_NOT_FOUND below would be a lie about it.
        if (step1.getAttribute("data-meta-landing") !== "true") return false;

        document.addEventListener("step1:results-loaded", function () {
            const choice = document.querySelector("[data-meta-choice]");
            // No pinned card means the clicked itinerary is not in the
            // results at all (sold out, or dropped by F-ENGINE), which is
            // precisely what FLIGHT_NOT_FOUND is for.
            if (!choice) return sendGoogleErrorEvent();

            const price = priceTransform(choice.getAttribute("data-meta-total-price") || '', currency);
            if (price.length === 0) return sendGoogleErrorEvent('OTHER', 'Price element was not found');

            return sendGooglePriceAccuracyEvent(price, currency);
        }, { once: true });
        return true;
    }

    const step2 = document.getElementById('step-2-data');

    // step2 page -> price accuracy event
    if (step2) {
        const price = priceTransform(document.getElementsByClassName('total-amount')[0].innerText, currency);

        if(price.length===0) {
            return sendGoogleErrorEvent(); // no data found -> send price accuracy error
        } else {
            return sendGooglePriceAccuracyEvent(price, currency)
        }
    }

    // booking page -> conversion event
    const booking = document.getElementById('booking-information');
    if (booking) {
        const adultCount = parseInt(booking.getAttribute('data-adult-number'));
        const childCount = parseInt(booking.getAttribute('data-child-number'));
        const infantCount = parseInt(booking.getAttribute('data-infant-number'));
        const items = JSON.parse(document.getElementById('google-flights-data').textContent);
        const routeType = booking.getAttribute('data-route-type');
        const transactionTotal = booking.getAttribute('data-transaction-total');

        return sendGoogleConversionEvent(
            routeType,
            transactionTotal,
            currency,
            {
                'total': adultCount+childCount+infantCount,
                'adult': adultCount,
                'child': childCount,
                'infant_in_lap': infantCount
            },
            items
        );
    }
});
